export const READING_PANE_TRANSLATION_TOAST_DIV_ID: string = 'RPTranslateToast';
